import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  HostListener,
  inject,
  input,
  InputSignal,
  Output
} from '@angular/core';
import { SzButtonComponent } from '../../controls/sz-button/sz-button.component';
import { SzIconComponent } from '../../display/sz-icon/sz-icon.component';
import { SzIconName } from '../../display/sz-icon/sz-icon-name.type';
import { SzWhatsNewChange } from './sz-whats-new-dialog.types';

const BODY_LOCK_CLASS: string = 'sz-body-scroll-lock';

// Fallback dla pustej nazwy. Sama nazwa pochodzi z reviewowanego JSON-a; zła nazwa
// renderuje pusty <use> (sz-icon), nie wywala widoku - więc nie walidujemy listy ikon.
const FALLBACK_ICON: SzIconName = 'star';

@Component({
  selector: 'sz-whats-new-dialog',
  templateUrl: './sz-whats-new-dialog.component.html',
  styleUrls: ['./sz-whats-new-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzButtonComponent, SzIconComponent]
})
export class SzWhatsNewDialogComponent {
  readonly open: InputSignal<boolean> = input<boolean>(false);
  readonly title: InputSignal<string> = input<string>('');
  readonly changes: InputSignal<ReadonlyArray<SzWhatsNewChange>> = input<ReadonlyArray<SzWhatsNewChange>>([]);
  readonly ctaLabel: InputSignal<string> = input<string>('OK');
  readonly dismissOnScrim: InputSignal<boolean> = input<boolean>(true);
  readonly dismissOnEsc: InputSignal<boolean> = input<boolean>(true);

  @Output() readonly close: EventEmitter<void> = new EventEmitter<void>();

  private readonly document: Document = inject(DOCUMENT);

  constructor() {
    effect((): void => {
      const isOpen: boolean = this.open();
      this.document.body.classList.toggle(BODY_LOCK_CLASS, isOpen);
    });
  }

  iconFor(raw: string): SzIconName {
    return (raw || FALLBACK_ICON) as SzIconName;
  }

  onScrimClick(): void {
    if (this.dismissOnScrim()) {
      this.close.emit();
    }
  }

  onClose(): void {
    this.close.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open() && this.dismissOnEsc()) {
      this.close.emit();
    }
  }
}
